export default "__VITE_ASSET__BwGuP$kE__"